import {
  SortAscendingOutlined,
  SortDescendingOutlined
} from "@ant-design/icons";
import { Button, Col, Dropdown, Form, Menu, Row } from "antd";
import React from "react";
import { TTranslate } from "../../../core/service/locale/TranslationService";
import { TSearchSortOrder } from "../../service/SearchService";

export interface Props {
  translate: TTranslate;
  sortOrder: TSearchSortOrder;
  sortFields: string[];
  field: string;
  onChangeSortOrder(field: string, sortOrder: TSearchSortOrder): any;
}

const SortOrderDropdown: React.FC<Props> = ({
  translate,
  onChangeSortOrder,
  sortOrder,
  sortFields,
  field
}: Props) => {
  const sortOrderItems = (
    <Menu
      onClick={(param) =>
        onChangeSortOrder(field, param.key as TSearchSortOrder)
      }
    >
      <Menu.Item key="asc">
        <SortAscendingOutlined /> {translate(`search.sort.asc`)}
      </Menu.Item>
      <Menu.Item key="desc">
        <SortDescendingOutlined /> {translate(`search.sort.desc`)}
      </Menu.Item>
    </Menu>
  );

  const sortOptions = (
    <Menu onClick={(param) => onChangeSortOrder(param.key, sortOrder)}>
      {sortFields?.map((item) => (
        <Menu.Item key={item}>{translate(`search.sort.${item}`)}</Menu.Item>
      ))}
    </Menu>
  );
  return (
    <Row>
      <Col span={24} style={{ display: "flex", justifyContent: "end" }}>
        <Form.Item label="Sortiraj prema" name="sortOrder">
          <Dropdown overlay={sortOptions}>
            <Button style={{ paddingTop: "5px" }}>
              {translate(`search.sort.${field}`)}
            </Button>
          </Dropdown>
          <Dropdown overlay={sortOrderItems}>
            <Button
              icon={
                sortOrder === "asc" ? (
                  <SortAscendingOutlined />
                ) : (
                  <SortDescendingOutlined />
                )
              }
              style={{
                marginLeft: "-2px",
                borderRadius: "0px 2px 2px 0px",
                top: "-1px"
              }}
            />
          </Dropdown>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default SortOrderDropdown;
